import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Card = styled.div`
  background: white;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const CardTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--vo-ink);
  margin: 0;
`;

const CopyBtn = styled.button`
  height: 34px;
  background: var(--vo-celeste);
  color: white;
  border: none;
  border-radius: 8px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  &:hover { background: var(--vo-cobalto); }
`;

const CodeBlock = styled.div`
  background: var(--vo-code-bg);
  border-radius: 10px;
  padding: 20px;
  overflow-x: auto;
`;

const CodeText = styled.code`
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: var(--vo-capri);
  white-space: pre;
`;

const Helper = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-slate);
  margin: 12px 0 0;
  line-height: 1.5;
`;

const HelperCode = styled.code`
  background: var(--vo-mist);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
`;

export const CardCookieBannerCode = ({ id, setShowCopySuccess }) => {
  const { t } = useTranslation(['cookies']);

  const codeSnippet = `<meta name="adopt-website-id" content="${id}" />\n<script src="//tag.goadopt.io/injector.js?website_code=${id}" class="adopt-injector"></script>`;

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(codeSnippet);
      setShowCopySuccess(true);
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('cookies:show.bannerCode.title')}</CardTitle>
        <CopyBtn onClick={copyCode}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
          </svg>
          {t('cookies:show.bannerCode.copyButton')}
        </CopyBtn>
      </CardHeader>
      <CodeBlock>
        <CodeText>{codeSnippet}</CodeText>
      </CodeBlock>
      <Helper>
        {t('cookies:show.bannerCode.helperBefore')}{' '}
        <HelperCode>{'<head>'}</HelperCode>
        {' '}{t('cookies:show.bannerCode.helperAfter')}
      </Helper>
    </Card>
  );
};
